import React, { useState, useEffect, useContext, useMemo } from "react";
import { Container, Grid, Card, Typography, Box, Radio, Button as MuiButton, IconButton } from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { axiosInstance } from "../component/Api/instance";
import { UserContext } from "../Context";
import { PageHeader } from "../component/ui/PageHeaders";
import { PrimaryButton, SecondaryButton } from "../component/ui/Buttons";
import { Dialog, DialogTitle, DialogContent, DialogActions, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VerifiedIcon from "@mui/icons-material/Verified";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import ShareIcon from "@mui/icons-material/Share";

import Correct from "../asserts/Component 322 – 3.png";
import Rong from "../asserts/Component 26 – 5.png";
import Web from "../asserts/_x36__stroke.png";
import Share1 from "../asserts/system-regular-1-share.gif";
import ScoreBoard from "../asserts/Score Board@2x.jpg";
import Whatapp from "../../src/asserts/whatapp.png";

const TestPageContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  padding: "32px 0",
  backgroundColor: theme.palette.background.default,
}));

const QuestionCard = styled(Card)(({ theme }) => ({
  borderRadius: "24px",
  padding: "32px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  minHeight: "550px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const SidebarCard = styled(Card)(({ theme }) => ({
  borderRadius: "24px",
  padding: "32px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const OptionContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected'
})(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  padding: "16px 20px",
  borderRadius: "16px",
  border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
  backgroundColor: selected ? `${theme.palette.primary.main}0D` : "transparent",
  marginBottom: "16px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: selected ? theme.palette.primary.main : theme.palette.text.secondary,
    backgroundColor: selected ? `${theme.palette.primary.main}0D` : theme.palette.action.hover,
  },
}));

const ImageBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "16px",
  overflow: "hidden",
  backgroundColor: theme.palette.action.hover,
  padding: "16px",
  marginBottom: "24px",
  cursor: "zoom-in",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
}));

const PaletteButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'status' && prop !== 'selected'
})(({ theme, status, selected }) => {
  let bgColor = theme.palette.background.paper;
  let textColor = theme.palette.text.primary;
  let borderColor = theme.palette.divider;

  if (status === "answered") {
    bgColor = theme.palette.success.main;
    textColor = theme.palette.success.contrastText;
    borderColor = theme.palette.success.main;
  } else if (status === "skipped") {
    bgColor = theme.palette.error.main;
    textColor = theme.palette.error.contrastText;
    borderColor = theme.palette.error.main;
  } else if (status === "review") {
    bgColor = theme.palette.warning.main;
    textColor = theme.palette.warning.contrastText;
    borderColor = theme.palette.warning.main;
  }

  return {
    width: "42px",
    height: "42px",
    fontWeight: 700,
    fontSize: "0.9rem",
    backgroundColor: bgColor,
    color: textColor,
    border: `2px solid ${selected ? theme.palette.primary.main : borderColor}`,
    borderRadius: "50%",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: status ? bgColor : theme.palette.action.hover,
      opacity: 0.9,
    },
  };
});

const StatusIndicator = styled(Box)(({ theme, color }) => ({
  width: "16px",
  height: "16px",
  borderRadius: "50%",
  backgroundColor: color,
  display: "inline-block",
  marginRight: "8px",
}));

export default function SubTest() {
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);
  const { sno, paperid } = useParams();
  const [options, setOptions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionsNo, setQuestionsNo] = useState([]);
  const [questioncount, setQuestioncount] = useState(0);
  const [responseData, setResponseData] = useState(null);
  const [responsecount, setResponsecount] = useState(null);
  const email = localStorage.getItem("userMail");
  const [questionStatus, setQuestionStatus] = useState([]);
  const [whatsapp, setWhatsapp] = useState([]);

  const location = useLocation();
  const { Endpoint } = useContext(UserContext);
  const navigate = useNavigate();
  const paperName = location.state?.paperName;

  const [Previewopen, setPreviewopen] = useState(false);
  const [open, setOpen] = useState(false);
  const [finish, setfinish] = useState(false);
  const [nextConfirmOpen, setNextConfirmOpen] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [optionIndexMapping, setOptionIndexMapping] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [openExplanationDialog, setOpenExplanationDialog] = useState(false);
  const [selectedExplanation, setSelectedExplanation] = useState("");
  const [previewIndex, setPreviewIndex] = useState(0);
  const [showExplanation, setShowExplanation] = useState(false);
  const [zoomImage, setZoomImage] = useState(false);

  useEffect(() => {
    fetchQuestionSno();
    Institution();
  }, []);

  const fetchQuestions = async (questionId) => {
    try {
      const res = await axiosInstance.post(`get/U_ViewSubWiseQuestions.php`, {
        userId: email,
        subjectId: sno,
        paperId: paperid,
        questionId: questionId,
      });
      if (res.status === 200 && res.data.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        setQuestions(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  const fetchQuestionSno = async () => {
    try {
      const res = await axiosInstance.post(
        `get/U_ViewSubWiseQuestionCount.php`,
        {
          userId: email,
          subjectId: sno,
          paperId: paperid,
        }
      );
      if (res.data.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        setQuestionsNo(res.data.data);
        handleQuestionChange2(res?.data?.data?.[0]?.sno);
        const count = res.data.length;
        setQuestioncount(count);
        setSelectedQuestionIndex(0);
      }
    } catch (error) {
      console.error("Error fetching question numbers:", error);
    }
  };

  const Institution = async () => {
    try {
      const response = await axiosInstance.post(`get/U_ViewStaticInfo.php`, {
        userId: email,
      });
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
        }
        setWhatsapp(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const registerDatas = async () => {
    try {
      const res = await axiosInstance.post(`get/U_viewSubjectPreview.php`, {
        userId: email,
        subject_id: sno,
        paper_id: paperid,
      });
      if (res.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        if (Array.isArray(res.data.data)) {
          setResponseData(res.data.data);
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const registerDatas1 = async () => {
    try {
      const res = await axiosInstance.post(`get/U_SubjectMark.php`, {
        userId: email,
        category_id: sno,
        paper_id: paperid,
      });
      if (res.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        if (Array.isArray(res.data)) {
          setResponsecount(res.data);
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const handleQuestionChange2 = async (questionSno) => {
    fetchQuestions(questionSno);
  };

  const handleQuestionChange = async (index) => {
    if (index >= 0 && index < questionsNo.length) {
      const selectedSno = questionsNo[index].sno;
      fetchQuestions(selectedSno);
      setSelectedQuestionIndex(index);

      if (index === questionsNo.length - 1) {
        await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      }
    }
  };

  const handlePrevQuestion = async () => {
    const prevIndex = selectedQuestionIndex - 1;
    if (prevIndex >= 0) {
      const selectedSno = questionsNo[prevIndex].sno;
      await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      await fetchQuestions(selectedSno);
      setSelectedQuestionIndex(prevIndex);

      const prevSavedOption = selectedOptions[prevIndex] || "";
      setSelectedOption(prevSavedOption);
      setSelectedOptionIndex(optionIndexMapping[prevIndex] ?? null);
    }
  };

  const handleNextClick = () => {
    if (selectedOptionIndex === null) {
      setNextConfirmOpen(true);
    } else {
      handleNextQuestion();
    }
  };

  const handleNextQuestion = async () => {
    const nextIndex = selectedQuestionIndex + 1;
    if (nextIndex < questionsNo.length) {
      const selectedSno = questionsNo[nextIndex].sno;
      await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      await fetchQuestions(selectedSno);
      setSelectedQuestionIndex(nextIndex);

      setSelectedOption(selectedOptions[nextIndex] || "");
      setSelectedOptionIndex(optionIndexMapping[nextIndex] ?? null);

      setQuestionStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[selectedQuestionIndex] = selectedOptions[selectedQuestionIndex]
          ? "answered"
          : "skipped";
        return newStatus;
      });
    } else if (nextIndex === questionsNo.length) {
      await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      setQuestionStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[selectedQuestionIndex] = selectedOption ? "answered" : "skipped";
        return newStatus;
      });
    }
  };

  const handleMarkQuestion = async () => {
    const nextIndex = selectedQuestionIndex + 1;
    await registerDatatest(questionsNo[selectedQuestionIndex].sno);

    setQuestionStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[selectedQuestionIndex] = "review";
      return newStatus;
    });

    if (nextIndex < questionsNo.length) {
      const selectedSno = questionsNo[nextIndex].sno;
      await fetchQuestions(selectedSno);
      setSelectedQuestionIndex(nextIndex);

      setSelectedOption(selectedOptions[nextIndex] || "");
      setSelectedOptionIndex(optionIndexMapping[nextIndex] ?? null);
    }
  };

  const handleSkipQuestion = async () => {
    setQuestionStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[selectedQuestionIndex] = "skipped";
      return newStatus;
    });
    await handleNextQuestion();
  };

  const registerDatatest = async (questionId) => {
    try {
      const res = await axiosInstance.post(`put/U_updateSubTestAns.php`, {
        id: email,
        question_id: questionId,
        answer: selectedOption,
      });
      if (res.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        setSelectedOption("");
      }
    } catch (err) {
      console.error("Error updating answer:", err);
    }
  };

  const handleOptionSelect = (optionIndex) => {
    const selectedOptionText = questions[0][`option${optionIndex}`];
    setSelectedOptionIndex(optionIndex);
    setSelectedOption(selectedOptionText);

    setSelectedOptions((prevOptions) => {
      const updatedOptions = [...prevOptions];
      updatedOptions[selectedQuestionIndex] = selectedOptionText;
      return updatedOptions;
    });

    setOptionIndexMapping((prevMapping) => ({
      ...prevMapping,
      [selectedQuestionIndex]: optionIndex,
    }));
  };

  const PreviewhandleClickOpen = () => {
    setPreviewopen(true);
  };

  const PreviewhandleClose = () => {
    setPreviewopen(false);
    navigate("/subject");
  };

  const correctCount = responseData
    ? responseData.filter(
        (q) => q.student_answer && q.student_answer === q.correct_answer
      ).length
    : 0;

  const wrongCount = responseData
    ? responseData.filter(
        (q) => q.student_answer && q.student_answer !== q.correct_answer
      ).length
    : 0;

  const sharePreviewQuestion = (q) => {
    const text = `Question ${previewIndex + 1}:
${q.questions}

A) ${q.option1 || ""}
B) ${q.option2 || ""}
${q.option3 ? `C) ${q.option3}` : ""}
${q.option4 ? `D) ${q.option4}` : ""}

Correct Answer:
${q.correct_answer}`;
    const phoneNumber = "917418581443";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const FinishTest = () => {
    setfinish(true);
  };

  const FinishTestClose = () => {
    setfinish(false);
    navigate("/subject");
  };

  const handleExplanationClick = (explanation) => {
    setSelectedExplanation(explanation);
    setOpenExplanationDialog(true);
  };

  const handleExplanationClose = () => {
    setOpenExplanationDialog(false);
    setSelectedExplanation("");
  };

  const isImage = (url) => {
    return url && url.match(/\.(jpeg|jpg|gif|png|svg|webp|jfif)$/) != null;
  };

  useEffect(() => {
    if (optionIndexMapping[selectedQuestionIndex] !== undefined) {
      setSelectedOptionIndex(optionIndexMapping[selectedQuestionIndex]);
    } else {
      setSelectedOptionIndex(null);
    }
  }, [selectedQuestionIndex, optionIndexMapping]);

  return (
    <TestPageContainer>
      <Container maxWidth="xl">
        {questions.length > 0 ? (
          <Box>
            <PageHeader 
              title={paperName || "Practice Examination Panel"}
              subtitle={`Question Progress: ${selectedQuestionIndex + 1} of ${questionsNo.length}`}
              onBack={() => navigate("/subject")}
            />

            <Grid container spacing={4}>
              <Grid item xs={12} lg={8}>
                <QuestionCard>
                  <Box>
                    <Typography 
                      variant="h2" 
                      style={{ fontWeight: 700, marginBottom: "24px", lineHeight: 1.5 }}
                    >
                      {selectedQuestionIndex + 1}. {questions[0].questions}
                    </Typography>

                    {questions[0].image && (
                      <ImageBox onClick={() => setZoomImage(!zoomImage)}>
                        <img
                          src={`${Endpoint}pppp/controllers/api/admin/upload/${questions[0].image}`}
                          alt="Question Graphic"
                          style={{
                            maxHeight: zoomImage ? "350px" : "180px",
                            maxWidth: "100%",
                            objectFit: "contain",
                            transform: zoomImage ? "scale(1.08)" : "scale(1)",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </ImageBox>
                    )}

                    <Box style={{ marginTop: "16px" }}>
                      {[1, 2, 3, 4].map((optionIndex) => {
                        const optionText = questions[0][`option${optionIndex}`];
                        const isSelected = selectedOptionIndex === optionIndex;

                        return (
                          <OptionContainer
                            key={optionIndex}
                            selected={isSelected}
                            onClick={() => handleOptionSelect(optionIndex)}
                          >
                            <Radio
                              checked={isSelected}
                              value={optionIndex}
                              color="primary"
                              style={{ padding: "0 12px 0 0" }}
                            />
                            {isImage(optionText) ? (
                              <img
                                src={`${Endpoint}pppp/controllers/api/admin/upload/${optionText}`}
                                alt={`Option ${optionIndex}`}
                                style={{ maxHeight: "70px", borderRadius: "8px" }}
                              />
                            ) : (
                              <Typography variant="body1" style={{ fontWeight: 550 }}>
                                {optionText}
                              </Typography>
                            )}
                          </OptionContainer>
                        );
                      })}
                    </Box>
                  </Box>

                  <Box style={{ display: "flex", gap: "12px", marginTop: "32px", flexWrap: "wrap" }}>
                    <SecondaryButton
                      disabled={selectedQuestionIndex === 0}
                      onClick={handlePrevQuestion}
                      startIcon={<ArrowBackIcon />}
                      style={{ height: "46px", borderRadius: "14px", minWidth: "120px" }}
                    >
                      Previous
                    </SecondaryButton>
                    <SecondaryButton
                      onClick={handleMarkQuestion}
                      style={{ height: "46px", borderRadius: "14px", minWidth: "120px" }}
                    >
                      Review Later
                    </SecondaryButton>
                    <SecondaryButton
                      onClick={handleSkipQuestion}
                      style={{ height: "46px", borderRadius: "14px", minWidth: "100px" }}
                    >
                      Skip
                    </SecondaryButton>
                    <PrimaryButton
                      onClick={handleNextClick}
                      endIcon={<ArrowForwardIcon />}
                      style={{ height: "46px", borderRadius: "14px", minWidth: "140px" }}
                    >
                      Save & Next
                    </PrimaryButton>
                  </Box>
                </QuestionCard>
              </Grid>

              <Grid item xs={12} lg={4}>
                <SidebarCard>
                  <Box>
                    <Box style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                      <HelpOutlineIcon color="primary" />
                      <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                        Question Status
                      </Typography>
                    </Box>

                    <Box style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px", flexWrap: "wrap", gap: "8px" }}>
                      <Box style={{ display: "flex", alignItems: "center" }}>
                        <StatusIndicator color="green" />
                        <Typography variant="caption" style={{ fontWeight: 600 }}>Answered</Typography>
                      </Box>
                      <Box style={{ display: "flex", alignItems: "center" }}>
                        <StatusIndicator color="rgba(252, 225, 53, 0.99)" />
                        <Typography variant="caption" style={{ fontWeight: 600 }}>Review</Typography>
                      </Box>
                      <Box style={{ display: "flex", alignItems: "center" }}>
                        <StatusIndicator color="red" />
                        <Typography variant="caption" style={{ fontWeight: 600 }}>Skipped</Typography>
                      </Box>
                    </Box>

                    <Box 
                      style={{ 
                        backgroundColor: "var(--color-background-secondary)", 
                        borderRadius: "16px", 
                        padding: "16px", 
                        maxHeight: "300px", 
                        overflowY: "auto", 
                        display: "flex", 
                        flexWrap: "wrap", 
                        gap: "12px" 
                      }}
                    >
                      {questionsNo.map((question, index) => (
                        <PaletteButton
                          key={index}
                          status={questionStatus[index]}
                          selected={selectedQuestionIndex === index}
                          onClick={() => handleQuestionChange(index)}
                        >
                          {index + 1}
                        </PaletteButton>
                      ))}
                    </Box>
                  </Box>

                  <Box style={{ marginTop: "40px" }}>
                    <PrimaryButton
                      onClick={handleClickOpen}
                      style={{
                        width: "100%",
                        height: "48px",
                        borderRadius: "16px",
                        background: "linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)",
                        boxShadow: "0 4px 12px rgba(220, 38, 38, 0.2)",
                        fontWeight: 700,
                      }}
                    >
                      Finish Test
                    </PrimaryButton>
                  </Box>
                </SidebarCard>
              </Grid>
            </Grid>

            {/* Confirm Finish Dialog */}
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Finish Test</DialogTitle>
              <DialogContent dividers>
                <Typography>Are you sure you want to finish the Test?</Typography>
                {(() => {
                  const answeredCount = Object.keys(optionIndexMapping).filter(
                    (key) => optionIndexMapping[key] !== null && optionIndexMapping[key] !== undefined
                  ).length;
                  const unansweredCount = questionsNo.length - answeredCount;
                  if (unansweredCount > 0) {
                    return (
                      <Typography color="error" style={{ marginTop: "10px", fontWeight: 600 }}>
                        Warning: You have {unansweredCount} unanswered questions.
                      </Typography>
                    );
                  }
                  return null;
                })()}
              </DialogContent>
              <DialogActions>
                <PrimaryButton 
                  onClick={() => {
                    FinishTest();
                    registerDatas1();
                    registerDatas();
                  }}
                >
                  Yes, Finish Test
                </PrimaryButton>
                <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
              </DialogActions>
            </Dialog>

            {/* Confirm Next Without Answer Dialog */}
            <Dialog open={nextConfirmOpen} onClose={() => setNextConfirmOpen(false)}>
              <DialogTitle>No Answer Selected</DialogTitle>
              <DialogContent dividers>
                <Typography>You have not selected an answer for this question. Do you want to proceed to the next question?</Typography>
              </DialogContent>
              <DialogActions>
                <SecondaryButton onClick={() => setNextConfirmOpen(false)}>Cancel</SecondaryButton>
                <PrimaryButton 
                  onClick={() => {
                    setNextConfirmOpen(false);
                    handleNextQuestion();
                  }}
                  color="warning"
                >
                  Proceed
                </PrimaryButton>
              </DialogActions>
            </Dialog>

            {/* Finish Score Dialog */}
            <Dialog open={finish} onClose={FinishTestClose}>
              <DialogTitle>Test Results</DialogTitle>
              <DialogContent dividers>
                <Typography style={{ fontWeight: 700, color: "green", marginBottom: "16px" }}>
                  Thank you, your test is submitted successfully.
                </Typography>
                {responsecount && responsecount.length > 0 ? (
                  responsecount.map((item, index) => (
                    <Box key={index} style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      <Typography variant="body1">Correct Answer: <b>{item.correct_count}</b></Typography>
                      <Typography variant="body1">Wrong Answer: <b>{item.incorrect_count}</b></Typography>
                      <Typography variant="body1">Skipped: <b>{item.skip_count}</b></Typography>
                      <Typography variant="body1">Negative Mark: <b>{item.negative_marks}</b></Typography>
                      <Typography variant="body1">Total Mark: <b>{item.total_marks}</b></Typography>
                    </Box>
                  ))
                ) : (
                  <Typography>Loading scorecard details...</Typography>
                )}
              </DialogContent>
              <DialogActions style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "16px 24px" }}>
                <SecondaryButton onClick={PreviewhandleClickOpen} startIcon={<VisibilityIcon />}>
                  Preview Answers
                </SecondaryButton>
                <SecondaryButton 
                  onClick={() => {
                    if (responsecount && responsecount.length > 0) {
                      const score = responsecount[0]?.total_marks || 0;
                      const totalMarks = responsecount[0]?.total_questions || 0;
                      const shareText = `I scored ${score}/${totalMarks} in the Nursing Update Test!`;
                      const canvas = document.createElement("canvas");
                      const context = canvas.getContext("2d");
                      canvas.width = 800;
                      canvas.height = 450;

                      const image = new Image();
                      image.src = ScoreBoard;
                      image.onload = () => {
                        context.drawImage(image, 0, 0, canvas.width, canvas.height);
                        context.font = "30px Arial";
                        context.fillStyle = "black";
                        context.textAlign = "right";

                        const lines = shareText.split(" Nursing ");
                        context.fillText(lines[0], canvas.width / 2, canvas.height / 2 - 20);
                        context.fillText("Nursing Update Test!", canvas.width / 2, canvas.height / 2 + 20);

                        canvas.toBlob((blob) => {
                          const imageUrl = URL.createObjectURL(blob);
                          navigator.clipboard.writeText(shareText).then(() => {
                            if (window.confirm("Score copied to clipboard! Click OK to share the image on Instagram.")) {
                              const link = document.createElement("a");
                              link.href = imageUrl;
                              link.download = "score-image.png";
                              link.click();
                              window.open("https://www.instagram.com/", "_blank");
                            }
                          });
                        }, "image/png");
                      };
                    }
                  }}
                  startIcon={<ShareIcon />}
                >
                  Share Score
                </SecondaryButton>
                <PrimaryButton onClick={FinishTestClose}>Done</PrimaryButton>
              </DialogActions>
            </Dialog>

            {/* Preview Answers Dialog */}
            <Dialog 
              open={Previewopen} 
              onClose={PreviewhandleClose} 
              maxWidth="xl" 
              fullWidth
              PaperProps={{
                style: {
                  backgroundColor: "var(--color-background)",
                  color: "var(--color-text-primary)",
                  borderRadius: "20px",
                }
              }}
            >
              <DialogTitle 
                style={{ 
                  display: "flex", 
                  justifyContent: "space-between", 
                  alignItems: "center",
                  backgroundColor: "var(--color-paper)",
                  color: "var(--color-text-primary)",
                  borderBottom: "1px solid var(--color-border)"
                }}
              >
                <Typography variant="h6" style={{ fontWeight: 700 }}>Test Preview</Typography>
                <IconButton onClick={PreviewhandleClose} size="small" style={{ color: "var(--color-text-primary)" }}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              
              <DialogContent 
                dividers 
                style={{ 
                  backgroundColor: "var(--color-background)", 
                  padding: "25px",
                  borderBottom: "1px solid var(--color-border)"
                }}
              >
                {responseData && responseData.length > 0 ? (
                  <Container maxWidth={false} style={{ padding: 0 }}>
                    <Grid container spacing={4}>
                      
                      {/* LEFT COLUMN: QUESTION CARD */}
                      <Grid item xs={12} lg={7}>
                        <Paper
                          elevation={0}
                          style={{
                            backgroundColor: "var(--color-paper)",
                            color: "var(--color-text-primary)",
                            borderRadius: "20px",
                            padding: "25px",
                            border: "1px solid var(--color-border)",
                            minHeight: "478px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          }}
                        >
                          <Box>
                            <Typography variant="subtitle2" style={{ fontWeight: 600, color: "var(--color-primary)", marginBottom: "15px" }}>
                              Question {previewIndex + 1} of {responseData.length}
                            </Typography>

                            <Typography variant="h6" style={{ fontWeight: 700, marginBottom: "20px", lineHeight: 1.5 }}>
                              {previewIndex + 1}. {responseData[previewIndex].questions}
                            </Typography>

                            {/* Image if any */}
                            {responseData[previewIndex].image && (
                              <Box style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                                <img
                                  src={`${Endpoint}/controllers/api/admin/upload/${responseData[previewIndex].image}`}
                                  alt="Question Illustration"
                                  style={{ maxHeight: "200px", maxWidth: "100%", borderRadius: "10px", objectFit: "contain" }}
                                />
                              </Box>
                            )}

                            {/* Radio Options */}
                            <Box style={{ marginTop: "20px" }}>
                              {["option1", "option2", "option3", "option4"].map((optKey, index) => {
                                const optionValue = responseData[previewIndex][optKey];
                                if (!optionValue) return null;

                                const isCorrect = optionValue === responseData[previewIndex].correct_answer;
                                const isStudentAnswer = optionValue === responseData[previewIndex].student_answer;

                                let bgColor = "var(--color-background)";
                                let borderColor = "var(--color-border)";
                                let checked = false;
                                let accentColor = "var(--color-primary)";

                                if (isCorrect) {
                                  bgColor = "rgba(76, 175, 80, 0.15)";
                                  borderColor = "#2e7d32";
                                  checked = true;
                                  accentColor = "#2e7d32";
                                } else if (isStudentAnswer && optionValue !== responseData[previewIndex].correct_answer) {
                                  bgColor = "rgba(211, 47, 47, 0.15)";
                                  borderColor = "#d32f2f";
                                  checked = true;
                                  accentColor = "#d32f2f";
                                }

                                return (
                                  <label
                                    key={index}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "14px 16px",
                                      marginBottom: "12px",
                                      borderRadius: "12px",
                                      border: `1.5px solid ${borderColor}`,
                                      backgroundColor: bgColor,
                                      cursor: "pointer",
                                      transition: "all 0.2s ease"
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      checked={checked}
                                      readOnly
                                      style={{
                                        marginRight: "12px",
                                        width: "18px",
                                        height: "18px",
                                        accentColor: accentColor
                                      }}
                                    />
                                    {isImage(optionValue) ? (
                                      <img
                                        src={`${Endpoint}/controllers/api/admin/upload/${optionValue}`}
                                        alt={`Option ${index + 1}`}
                                        style={{ maxHeight: "80px", borderRadius: "8px" }}
                                      />
                                    ) : (
                                      <span style={{ fontSize: "15px", fontWeight: 550 }}>
                                        {optionValue}
                                      </span>
                                    )}
                                  </label>
                                );
                              })}
                            </Box>

                            {/* Explanation */}
                            {responseData[previewIndex].explanation && (
                              <Box style={{ marginTop: "20px" }}>
                                <Typography
                                  onClick={() => setShowExplanation(!showExplanation)}
                                  style={{
                                    color: "var(--color-primary)",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    display: "inline-block"
                                  }}
                                >
                                  {showExplanation ? "Hide Explanation" : "Show the explanation"}
                                </Typography>
                                {showExplanation && (
                                  <Paper
                                    elevation={0}
                                    style={{
                                      marginTop: "10px",
                                      padding: "15px",
                                      backgroundColor: "var(--color-background)",
                                      border: "1px solid var(--color-border)",
                                      borderRadius: "10px"
                                    }}
                                  >
                                    <Typography variant="body2" style={{ lineHeight: 1.6 }}>
                                      {responseData[previewIndex].explanation}
                                    </Typography>
                                  </Paper>
                                )}
                              </Box>
                            )}
                          </Box>

                          {/* Share on WhatsApp */}
                          {whatsapp && whatsapp.length > 0 && (
                            <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                              <div
                                onClick={() => sharePreviewQuestion(responseData[previewIndex])}
                                style={{ cursor: "pointer" }}
                              >
                                <img src={Whatapp} height="35px" alt="WhatsApp Share" />
                              </div>
                            </Box>
                          )}
                        </Paper>
                      </Grid>

                      {/* RIGHT COLUMN: NAVIGATOR PALETTE */}
                      <Grid item xs={12} lg={5}>
                        <Paper
                          elevation={0}
                          style={{
                            backgroundColor: "var(--color-paper)",
                            color: "var(--color-text-primary)",
                            borderRadius: "20px",
                            padding: "25px",
                            height: "478px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            border: "1px solid var(--color-border)",
                          }}
                        >
                          <Box>
                            <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                              <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                                Question Palette
                              </Typography>
                              <Box style={{ display: "flex", gap: "15px" }}>
                                <Typography style={{ color: "#4caf50", fontWeight: 700 }}>
                                  ✅ {correctCount}
                                </Typography>
                                <Typography style={{ color: "#f44336", fontWeight: 700 }}>
                                  ❌ {wrongCount}
                                </Typography>
                              </Box>
                            </Box>

                            {/* Scrollable Circle Grid */}
                            <Box
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "10px",
                                height: "350px",
                                overflowY: "auto",
                                paddingRight: "5px"
                              }}
                            >
                              {responseData.map((q, idx) => {
                                const isCorrect = q.student_answer && q.student_answer === q.correct_answer;
                                const isWrong = q.student_answer && q.student_answer !== q.correct_answer;

                                let bgColor = "var(--color-border)";
                                let textColor = "var(--color-text-primary)";
                                let borderStyle = "none";

                                if (isCorrect) {
                                  bgColor = "#4caf50";
                                  textColor = "white";
                                } else if (isWrong) {
                                  bgColor = "#f44336";
                                  textColor = "white";
                                }

                                if (idx === previewIndex) {
                                  borderStyle = "3px solid var(--color-primary)";
                                }

                                return (
                                  <button
                                    key={idx}
                                    onClick={() => {
                                      setPreviewIndex(idx);
                                      setShowExplanation(false);
                                    }}
                                    style={{
                                      width: "45px",
                                      height: "45px",
                                      borderRadius: "50%",
                                      border: borderStyle,
                                      fontWeight: 700,
                                      backgroundColor: bgColor,
                                      color: textColor,
                                      cursor: "pointer",
                                      transition: "all 0.2s ease"
                                    }}
                                  >
                                    {idx + 1}
                                  </button>
                                );
                              })}
                            </Box>
                          </Box>

                          {/* Previous / Next buttons */}
                          <Box style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                            <MuiButton
                              variant="outlined"
                              color="primary"
                              disabled={previewIndex === 0}
                              onClick={() => {
                                setPreviewIndex(previewIndex - 1);
                                setShowExplanation(false);
                              }}
                              style={{ borderRadius: "12px", minWidth: "100px" }}
                            >
                              Previous
                            </MuiButton>
                            <MuiButton
                              variant="contained"
                              color="primary"
                              disabled={previewIndex === responseData.length - 1}
                              onClick={() => {
                                setPreviewIndex(previewIndex + 1);
                                setShowExplanation(false);
                              }}
                              style={{ borderRadius: "12px", minWidth: "100px" }}
                            >
                              Next
                            </MuiButton>
                          </Box>
                        </Paper>
                      </Grid>
 
                    </Grid>
                  </Container>
                ) : (
                  <Typography align="center" style={{ padding: "40px", color: "var(--color-text-primary)" }}>
                    No preview data available.
                  </Typography>
                )}
              </DialogContent>
            </Dialog>

            {/* Explanation Dialog */}
            <Dialog open={openExplanationDialog} onClose={handleExplanationClose} maxWidth="md" fullWidth>
              <DialogTitle>Explanation</DialogTitle>
              <DialogContent dividers>
                <Typography variant="body1">{selectedExplanation || "No explanation provided."}</Typography>
              </DialogContent>
              <DialogActions>
                <PrimaryButton onClick={handleExplanationClose}>Close</PrimaryButton>
              </DialogActions>
            </Dialog>
          </Box>
        ) : (
          <Typography align="center" style={{ marginTop: "100px" }}>Loading exam question data...</Typography>
        )}
      </Container>
    </TestPageContainer>
  );
}
